import { useState } from 'react';
import cn from 'classnames';
// Types
import type { UserFields_hashtags } from 'api/auth/types/UserFields';
import { GetStoreBySlug_store_socialMedia } from 'api/store/types/GetStoreBySlug';
// Component
import SocialNetwork from 'components/common3/SocialNetworks/SocialNetworks';
// Helpers
import { parseForInnerHTML } from 'helpers/textEditor';
// Ui3
import EllipsisText from 'ui3/EllipsisText/EllipsisText';
import HashTags from 'ui3/HashTags/HashTags';

import styles from './About.module.scss';

export type BioAndHashtagsProps = {
  bioText: string;
  hashtags: UserFields_hashtags[];
  links: GetStoreBySlug_store_socialMedia[];
  showFullBio?: boolean;
};

const AboutStore = ({
  bioText,
  hashtags,
  links,
  showFullBio = true,
}: BioAndHashtagsProps) => {
  const [showMore, setShowMore] = useState<boolean>(false);

  const hasBio = !!bioText?.trim();
  const hasTags = !!hashtags?.length;
  const hasLinks = !!links?.length;

  return (
    <div className={styles.root}>
      <div className={styles.aboutContentWrapper}>
        {hasBio && (
          <div>
            <p className={styles.label}>BIO</p>
            {showFullBio ? (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{
                  __html: parseForInnerHTML(bioText),
                }}
              />
            ) : (
              <EllipsisText
                text={bioText}
                className={styles.description}
                maxLine={{ xs: 2, ml: 3 }}
                isGold
                setShowMore={setShowMore}
              />
            )}
          </div>
        )}

        {hasTags && (
          <div>
            <p className={styles.label}>TAGS</p>
            <HashTags
              tags={hashtags}
              variant="dark"
              className={cn(styles.hashtags, {
                [styles.tagsListColumn]: showMore,
              })}
            />
          </div>
        )}

        {hasLinks && (
          <SocialNetwork showExtra links={links} noBackgroundIcons />
        )}
      </div>
    </div>
  );
};

export default AboutStore;
